// extracted by mini-css-extract-plugin
export default {"success":"Success_success__J3jnx","details":"Success_details__6eoi4"};